// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__1hTMG","edit_section":"style_edit_section__28F3E"};